import React, { Component } from 'react';
import { getToken } from '../../../../config/index';
import Axios from 'axios';
import Spinner from 'react-bootstrap/Spinner';

export class Report extends Component {
  state = {
    loading: true,
    error: '',
  };

  handleBack = () => {
    this.props.next(-1);
  };

  handleNext = () => {
    this.props.next(1);
  };

  componentDidMount() {
    Axios.get('/api/app/quick_look/modulo7/report?id=' + this.props.id, {
      headers: { Authorization: 'Bearer ' + getToken() },
    }).then((response) => {
      if (response.data.ok) {
        this.setState(
          {
            loading: false,
            q1: response.data.data.q1,
            q2: response.data.data.q2.description,
            q3: response.data.data.q3.score,
          },
          () => {
            this.props.load();
          },
        );
      } else {
        this.setState(
          {
            error: response.data.error,
          },
          () => {
            this.props.load();
          },
        );
      }
    });
  }

  render() {
    return (
      <>
        {this.state.error === '' ? (
          <>
            {this.props.nonext ? (
              <p className="question-title">
                <b>7. Report</b>
              </p>
            ) : null}

            {this.state.loading ? (
              <div className="col-2 text-center mx-auto">
                <Spinner animation="border" variant="secondary" />
              </div>
            ) : (
              <>
                {/* Q1 */}
                <div className="dash-div my-3 p-4" style={{ width: '100%' }}>
                  <p className="text-center">
                    <b>
                      What are the three roles of the most influential actors?
                    </b>
                  </p>
                  <hr />
                  <div className="row">
                    <div className="border col-8 ml-auto">
                      <p className="my-1 font-bold">System Type</p>
                    </div>
                    <div className="border col-2 mr-auto">
                      <p className="my-1 font-bold">Score</p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="border col-8 ml-auto">
                      <p className="my-1">Enterprise</p>
                    </div>
                    <div className="border col-2 mr-auto">
                      <p className="my-1">{this.state.q1.savings}</p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="border col-8 ml-auto">
                      <p className="my-1">Eco-system</p>
                    </div>
                    <div className="border col-2 mr-auto">
                      <p className="my-1">{this.state.q1.income}</p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="border col-8 ml-auto">
                      <p className="my-1">Impact on Humans</p>
                    </div>
                    <div className="border col-2 mr-auto">
                      <p className="my-1">{this.state.q1.impact}</p>
                    </div>
                  </div>
                </div>

                {/* Q2 */}
                <div className="dash-div my-3 p-4" style={{ width: '100%' }}>
                  <p className="text-center">
                    <b>
                      The value proposition that embodies the essence of all the
                      problem-solving, pain reduction, and financial and human
                      impact to the customer.
                    </b>
                  </p>
                  <hr />
                  <div className="row">
                    <div className="col-10 mx-auto">
                      <p className="my-1">{this.state.q2}</p>
                    </div>
                  </div>
                </div>

                {/* Q3 */}
                <div className="dash-div my-3 p-4" style={{ width: '100%' }}>
                  <p className="text-center">
                    <b>
                      What is your overall level of confidence that your value
                      proposition to the customer would be embraced by them and
                      endorsed by all the other key actors?
                    </b>
                  </p>
                  <hr />
                  <div className="row">
                    <div className="border col-4 mx-auto">
                      <p className="my-1 text-center">{this.state.q3}</p>
                    </div>
                  </div>
                </div>

                {this.props.nonext ? (
                  <>
                    <hr />
                    <div
                      style={{
                        width: '100%',
                        justifyContent: 'space-between',
                        display: 'flex',
                      }}
                    >
                      <button
                        className="btn my-4 p-3"
                        style={{
                          color: 'white',
                          backgroundColor: '#cea977',
                          borderRadius: '10px',
                        }}
                        onClick={this.handleBack}
                      >
                        <i className="fas fa-arrow-left"></i> Back
                      </button>
                      <button
                        className="btn my-4 p-3"
                        style={{
                          color: 'white',
                          backgroundColor: '#cea977',
                          borderRadius: '10px',
                        }}
                        onClick={this.handleNext}
                      >
                        Next <i className="fas fa-arrow-right"></i>
                      </button>
                    </div>
                  </>
                ) : null}
              </>
            )}
          </>
        ) : (
          this.state.error
        )}
      </>
    );
  }
}

export default Report;
